import styled from '@emotion/styled';
import { Container, SkeletonBox } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const PageContainer = styled(Container)`
  margin-bottom: 100px;
  ${mediaQuery('small')} {
    margin-bottom: 50px;
  }
`;

export const SideLayoutStickyWrapper = styled.div`
  border-radius: 10px;
  top: 100px;
  position: sticky;
  margin-bottom: 50px;
`;

export const SlideshowSkeletonContainer = styled.div`
  width: 100%;
  ${mediaQuery('tablet')} {
    padding: 0px;
    width: 100%;
    float: none;
    margin-bottom: 25px;
  }
`;

export const SlideshowSkeletonMainWrapper = styled.div`
  position: relative;
  width: 100%;
  height: min-content;
  border-radius: 10px;
  overflow: hidden;
`;

export const SlideshowSkeletonMain = styled(SkeletonBox)`
  width: 100%;
  padding-bottom: 75%;
  display: block;

  position: relative;

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;
